import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBars, FaTimes, FaUser, FaShoppingCart, FaHeart } from 'react-icons/fa';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { decryptData } from '../Utils/encryption';
import { useDispatch, useSelector } from 'react-redux';
import { getUserById } from '../Redux/Slice/user.slice';
import { Modal } from '@mui/material';
import { logoutUser } from '../Redux/Slice/auth.slice';
import { AiOutlineClose } from 'react-icons/ai';
import { MdLogout } from "react-icons/md";
import { fetchWishlist } from '../Redux/Slice/wishlist.slice';
import { fetchCart } from '../Redux/Slice/cart.slice';
import { TbLayoutDashboard } from "react-icons/tb";
const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    // Cart count: fetch from backend and listen to updates from Redux store
    const cartItems = useSelector((state) => state.cart?.items || []);
    const wishlistItems = useSelector((state) => state.wishlist?.items || []);
    const [cartCount, setCartCount] = useState(0);
    const [wishlistCount, setWishlistCount] = useState(0);
    const [isScrolled, setIsScrolled] = useState(false);
    const navItems = [
        { name: 'Home', path: '/' },
        { name: 'Games', path: '/games' },
        { name: 'Blog', path: '/blog' },
        { name: 'About', path: '/about' },
        { name: 'Contact', path: '/contact' },
    ];
    const userId = localStorage.getItem('yoyouserId');
    const token = localStorage.getItem('yoyoToken');
    const role = localStorage.getItem('role');
    const currentUser = useSelector((state) => state.user.currUser);
    const dropdownRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        if (userId) {
            dispatch(getUserById(userId))
        }
    }, [dispatch, userId])
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setProfileDropdownOpen(false);
            }
        }
        if (profileDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [profileDropdownOpen]);

    useEffect(() => {
        if (userId && token) {
            dispatch(fetchWishlist());
            dispatch(fetchCart());
        }
    }, [userId && token])

    useEffect(() => {
        if (!(userId && token)) {
            setCartCount(0);
            setWishlistCount(0);
            return;
        }
        const count = Array.isArray(cartItems) ? cartItems.reduce((sum, it) => sum + (it?.qty || 1), 0) : 0;
        setCartCount(count);

        // Set wishlist count
        const wishlistCount = Array.isArray(wishlistItems) ? wishlistItems.length : 0;
        setWishlistCount(wishlistCount);
    }, [userId, token, cartItems, wishlistItems]);

    // Prevent background scroll when the mobile menu is open
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMenuOpen]);

    // Close menus with Escape key
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setIsMenuOpen(false);
                setProfileDropdownOpen(false);
                setShowLogoutModal(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    // Detect scroll to toggle background width
    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 0);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleProfileNavigation = () => {
        setProfileDropdownOpen(false);
        // Small delay to allow exit animation to complete
        setTimeout(() => {
            navigate("/profile");
            setProfileDropdownOpen(false);
        }, 200);
    };

    const handleLogout = async () => {
        if (userId) {
            await dispatch(logoutUser(userId));
        }
        localStorage.removeItem("yoyouserId");
        localStorage.removeItem("yoyoToken");
        localStorage.removeItem("role");
        navigate("/")
    }

    return (
        <header className="fixed top-0 left-0 right-0 z-50 text-white bg-transparent ">
            {/* <div className="absolute inset-x-0 top-0 h-[2px] bg-gradient-to-r z-50 from-purple-500 via-fuchsia-500 to-indigo-500" /> */}
            <div className="relative">
                <div className={`absolute inset-y-0 left-1/2 -translate-x-1/2  bg-white/5 border border-white/10 backdrop-blur shadow-[0_10px_30px_rgba(0,0,0,0.25)] transition-all duration-500 ease-in-out ${isScrolled ? 'w-screen' : 'w-[95%] sm:w-[92%] md:w-[90%] lg:w-[80%] rounded-2xl'}`}></div>
                <div className={`mx-auto w-[95%] sm:w-[92%] md:w-[90%] lg:max-w-[80%] flex justify-between items-center py-2 px-3 md:px-4 relative z-10 `}>
                    {/* Logo */}
                    <motion.div
                        onClick={() => { navigate('/') }}
                        initial={{ opacity: 0, y: -30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="text-2xl sm:text-3xl font-bold tracking-widest bg-gradient-to-r from-purple-500 via-fuchsia-500 to-indigo-500 bg-clip-text text-transparent"
                    >
                        {/* YOYO */}
                        <img
                            src={require('../Asset/images/onlyLogo.png')}
                            alt="logo"
                            className="w-10 h-10"
                            style={{
                                filter: 'drop-shadow(0 2px 8px #5C003B)'
                            }}
                        />
                    </motion.div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-2 lg:space-x-3">
                        {navItems.map((item) => {
                            // 'navigate' and 'location' are assumed to be available from `useNavigate()` and `useLocation()` hooks
                            // called at the top level of the Header component.
                            const isActive = item.path === '/' ? location.pathname === '/' : location.pathname.startsWith(item.path);
                            return (
                                <motion.div
                                    key={item.path}
                                    whileHover={{ scale: 1.05 }}
                                    className="relative text-gray-200 transition-all duration-300 hover:text-white group px-2 lg:px-3 py-2 rounded-lg hover:bg-white/5"
                                    onClick={() => navigate(item.path)}
                                >
                                    {/* <div className={`block cursor-none ${isActive ? 'text-purple-400' : ''}`}>
                                        {item.name}
                                        <span className={`absolute left-1/2 bottom-0 h-1 w-1 rounded-full bg-purple-400 -translate-x-1/2 transition-all duration-300 ${isActive ? 'scale-100 opacity-100' : 'scale-0 opacity-0 group-hover:scale-100 group-hover:opacity-100'}`} />
                                    </div> */}
                                    <div className={`block relative cursor-none ${isActive ? 'text-purple-400' : ''}`}>
                                        <span className="relative inline-block">
                                            {item.name}
                                            <span
                                                className={`
                                                absolute left-1/2 -bottom-0.5
                                                -translate-x-1/2
                                                h-[1px]
                                                bg-purple-400
                                                rounded-full
                                                transition-all duration-300
                                                ${isActive ? 'w-full opacity-100' : 'w-0 opacity-0 group-hover:w-full group-hover:opacity-100'}
                                            `}
                                                style={{ minWidth: 0, maxWidth: '100%' }}
                                            />
                                        </span>
                                    </div>
                                </motion.div>
                            );
                        })}
                    </nav>

                    {/* Desktop Right Actions */}
                    <div className="hidden md:flex items-center gap-3">
                        {userId && token && (
                            <>
                                <button onClick={() => navigate('/wishlist')} aria-label="Wishlist" className="relative w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 border-white/40 flex items-center justify-center text-gray-200 hover:text-red-400 transition-colors group hover:border-red-400">
                                    <FaHeart size={16} />
                                    {wishlistCount > 0 && (
                                        <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 bg-red-500 text-[10px] leading-4 rounded-full flex items-center justify-center text-white font-bold">
                                            {wishlistCount}
                                        </span>
                                    )}
                                </button>
                                <button onClick={() => navigate('/cart')} aria-label="Cart" className="relative w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 border-white/40 flex items-center justify-center text-gray-200 hover:text-purple-400 transition-colors group hover:border-purple-400">
                                    <FaShoppingCart size={16} />
                                    {cartCount > 0 && (
                                        <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 bg-red-500 text-[10px] leading-4 rounded-full flex items-center justify-center text-white font-bold">
                                            {cartCount}
                                        </span>
                                    )}
                                </button>
                            </>
                        )}
                        {userId && token ? (
                            <motion.div
                                className="flex relative text-gray-200 hover:text-purple-400 transition-all duration-300 items-center gap-1 group"
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                onClick={() => setProfileDropdownOpen((prev) => !prev)}
                                ref={dropdownRef}
                            >
                                <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center">
                                    {currentUser?.photo && currentUser?.photo !== "null" ? (
                                        <img
                                            src={currentUser.photo}
                                            alt="Profile"
                                            className="w-full h-full rounded-full object-cover"
                                        />
                                    ) : (
                                        <span
                                            className="text-base w-8 h-8 sm:w-9 sm:h-9 font-bold uppercase border-2 rounded-full flex justify-center items-center border-white/40 group-hover:border-purple-400"
                                        >
                                            {decryptData(currentUser?.userName)?.split(" ").map(name => name[0]?.toUpperCase())?.join("") || ""}
                                        </span>
                                    )}
                                </div>
                                {currentUser && (
                                    <span
                                        className="hidden md600:block font-medium capitalize transition-colors max-w-[140px] truncate"
                                    >
                                        {decryptData(currentUser?.userName)}
                                    </span>
                                )}
                                <span style={{ minWidth: 0, maxWidth: '100%' }} className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-0 h-[1px] bg-purple-400 transition-all duration-300 group-hover:w-full" />

                                {/* Profile dropdown with AnimatePresence for exit animations */}
                                <AnimatePresence>
                                    {profileDropdownOpen && (
                                        <motion.div
                                            className="absolute top-[43px] right-0 mt-2 w-44 bg-[#18181b] rounded-xl shadow-lg z-50 border border-white/10"
                                            initial={{ opacity: 0, x: 40, scale: 0.9 }}
                                            animate={{ opacity: 1, x: 0, scale: 1 }}
                                            exit={{ opacity: 0, x: 40, scale: 0.9 }}
                                            transition={{
                                                duration: 0.2,
                                                ease: "easeInOut"
                                            }}
                                        >
                                            <button
                                                className="w-full text-left px-4 py-2 flex gap-2 items-center hover:bg-white/5 text-gray-200 hover:text-purple-400 transition-colors"
                                                onClick={() => { handleProfileNavigation(); setProfileDropdownOpen(false) }}
                                            >
                                                <div>
                                                    <FaUser />
                                                </div>
                                                <div>
                                                    Profile
                                                </div>
                                            </button>
                                            {(role === "admin") && <button
                                                className="w-full text-left px-4 py-2 flex gap-2 items-center hover:bg-white/5 text-gray-200 hover:text-purple-400 transition-colors"
                                                onClick={() => { navigate('/admin'); setProfileDropdownOpen(false) }}
                                            >
                                                <div>
                                                    < TbLayoutDashboard/>
                                                </div>
                                                <div>
                                                   Dashboard
                                                </div>
                                            </button>}
                                            <button
                                                className="w-full text-left px-4 py-2 flex gap-1 items-center hover:bg-white/5 text-gray-200 border-t border-white/10 hover:text-red-500 transition-colors"
                                                onClick={() => {
                                                    setProfileDropdownOpen(false);
                                                    setShowLogoutModal(true);

                                                }}
                                            >
                                                <div className='text-xl'>
                                                    <MdLogout />
                                                </div>
                                                <div>
                                                    Logout
                                                </div>
                                            </button>
                                        </motion.div>
                                    )}
                                </AnimatePresence>

                                <Modal
                                    open={showLogoutModal}
                                    onClose={() => { setShowLogoutModal(false) }}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                    className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 cursor-none"
                                >
                                    <div className="bg-[#1e1e1e] rounded-[2px] p-[16px] sm:p-[24px] w-[90%] max-w-[400px] text-white shadow-lg">
                                        <div className="flex justify-between items-center border-b border-white/10 pb-3">
                                            <h2 id="modal-modal-title" className="text-lg font-semibold">Log out</h2>
                                            <button
                                                onClick={() => setShowLogoutModal(false)}
                                                className="text-white hover:text-red-500 transition duration-200 cursor-none"
                                            >
                                                <AiOutlineClose className="text-xl" />
                                            </button>
                                        </div>

                                        <p id="modal-modal-description" className="text-sm text-white/70 text-center my-6">
                                            Are you sure you want to logout?
                                        </p>

                                        <div className="flex justify-between gap-4 mt-4">
                                            <button
                                                onClick={() => setShowLogoutModal(false)}
                                                className="w-full bg-white/10 hover:bg-white/20 text-white py-2 ease-in-out rounded-[4px] transition-all duration-300 cursor-none"
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" onClick={() => { setShowLogoutModal(false); handleLogout(); }} className="w-full text-white py-2 rounded-[4px] text-[14px] font-medium sm:py-3 bg-gradient-primary border-none transition-all duration-400 ease-in-out cursor-none"
                                            >
                                                Yes, Logout
                                            </button>
                                        </div>
                                    </div>
                                </Modal>
                            </motion.div>
                        ) : (
                            <motion.div
                                onClick={() => { navigate('/login') }}
                                className="flex relative gap-1 items-center text-gray-200 transition-all duration-300 hover:text-purple-400 group"
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 border-white/40 flex items-center justify-center transition-colors group-hover:border-purple-400">
                                    <FaUser size={16} />
                                </div>
                                <span
                                    className="transition-colors font-medium"
                                >
                                    Sign in
                                </span>
                                <span style={{ minWidth: 0, maxWidth: '100%' }} className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-0 h-[1px] bg-purple-400 transition-all duration-300 group-hover:w-full" />
                            </motion.div>
                        )}
                    </div>

                    {/* Mobile Actions: cart first, then profile/sign-in, then hamburger */}
                    <div className="md:hidden flex items-center gap-3">
                        {userId && token && (
                            <>
                                <button onClick={() => navigate('/wishlist')} aria-label="Wishlist" className="relative w-8 h-8 rounded-full border-2 border-white/40 flex items-center justify-center text-gray-200 hover:text-red-400 transition-colors group hover:border-red-400">
                                    <FaHeart size={16} />
                                    {wishlistCount > 0 && (
                                        <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 bg-red-500 text-[10px] leading-4 rounded-full flex items-center justify-center text-white font-bold">
                                            {wishlistCount}
                                        </span>
                                    )}
                                </button>
                                <button onClick={() => navigate('/cart')} aria-label="Cart" className="relative w-8 h-8 rounded-full border-2 border-white/40 flex items-center justify-center text-gray-200 hover:text-purple-400 transition-colors group hover:border-purple-400">
                                    <FaShoppingCart size={16} />
                                    {cartCount > 0 && (
                                        <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 bg-red-500 text-[10px] leading-4 rounded-full flex items-center justify-center text-white font-bold">
                                            {cartCount}
                                        </span>
                                    )}
                                </button>
                            </>
                        )}
                        {userId && token ? (
                            <motion.div
                                className="relative flex text-gray-200 hover:text-purple-400 transition-all duration-300 items-center gap-1 group"
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                onClick={() => setProfileDropdownOpen((prev) => !prev)}
                                ref={dropdownRef}
                            >
                                <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center">
                                    {currentUser?.photo && currentUser?.photo !== "null" ? (
                                        <img
                                            src={currentUser.photo}
                                            alt="Profile"
                                            className="w-full h-full rounded-full object-cover"
                                        />
                                    ) : (
                                        <span
                                            className="text-base w-8 h-8 sm:w-9 sm:h-9 font-bold uppercase border-2 rounded-full flex justify-center items-center border-white/40 group-hover:border-purple-400"
                                        >
                                            {decryptData(currentUser?.userName)?.split(" ").map(name => name[0]?.toUpperCase())?.join("") || ""}
                                        </span>
                                    )}
                                </div>
                                {currentUser && (
                                    <span
                                        className="hidden md600:block font-medium capitalize transition-colors max-w-[120px] truncate"
                                    >
                                        {decryptData(currentUser?.userName)}
                                    </span>
                                )}
                                <span style={{ minWidth: 0, maxWidth: '100%' }} className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-0 h-[1px] bg-purple-400 transition-all duration-300 group-hover:w-full" />

                                {/* Profile dropdown with AnimatePresence for exit animations */}
                                <AnimatePresence>
                                    {profileDropdownOpen && (
                                        <motion.div
                                            className="absolute top-[43px] right-0 mt-2 w-44 bg-[#18181b] rounded-xl shadow-lg z-50 border border-white/10"
                                            initial={{ opacity: 0, x: 40, scale: 0.9 }}
                                            animate={{ opacity: 1, x: 0, scale: 1 }}
                                            exit={{ opacity: 0, x: 40, scale: 0.9 }}
                                            transition={{
                                                duration: 0.2,
                                                ease: "easeInOut"
                                            }}
                                        >
                                            <button
                                                className="w-full text-left flex gap-2 items-center px-4 py-2 hover:bg-white/5 text-gray-200 hover:text-purple-400 transition-colors"
                                                onClick={() => { handleProfileNavigation(); setProfileDropdownOpen(false) }}
                                            >
                                                <div>
                                                    <FaUser />
                                                </div>
                                                <div>
                                                    Profile
                                                </div>
                                            </button>
                                             {(role === "admin") && <button
                                                className="w-full text-left px-4 py-2 flex gap-2 items-center hover:bg-white/5 text-gray-200 hover:text-purple-400 transition-colors"
                                                onClick={() => { navigate('/admin'); setProfileDropdownOpen(false) }}
                                            >
                                                <div>
                                                    < TbLayoutDashboard/>
                                                </div>
                                                <div>
                                                   Dashboard
                                                </div>
                                            </button>}
                                            <button
                                                className="w-full text-left flex gap-1 items-center px-4 py-2 hover:bg-white/5 text-gray-200 border-t border-white/10 hover:text-red-500 transition-colors"
                                                onClick={() => {
                                                    setProfileDropdownOpen(false);
                                                    setShowLogoutModal(true);
                                                }}
                                            >
                                                <div className='text-xl'>
                                                    <MdLogout />
                                                </div>
                                                <div>
                                                    Logout
                                                </div>
                                            </button>
                                        </motion.div>
                                    )}
                                </AnimatePresence>

                                <Modal
                                    open={showLogoutModal}
                                    onClose={() => { setShowLogoutModal(false) }}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                    className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 cursor-none"
                                >
                                    <div className="bg-[#1e1e1e] rounded-[2px] p-[16px] sm:p-[24px] w-[90%] max-w-[400px] text-white shadow-lg">
                                        <div className="flex justify-between items-center border-b border-white/10 pb-3">
                                            <h2 id="modal-modal-title" className="text-lg font-semibold">Log out</h2>
                                            <button
                                                onClick={() => setShowLogoutModal(false)}
                                                className="text-white hover:text-red-500 transition duration-200 cursor-none"
                                            >
                                                <AiOutlineClose className="text-xl" />
                                            </button>
                                        </div>

                                        <p id="modal-modal-description" className="text-sm text-white/70 text-center my-6">
                                            Are you sure you want to logout?
                                        </p>

                                        <div className="flex justify-between gap-4 mt-4">
                                            <button
                                                onClick={() => setShowLogoutModal(false)}
                                                className="w-full bg-white/10 hover:bg-white/20 text-white py-2 ease-in-out rounded-[4px] transition-all duration-300 cursor-none"
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" onClick={() => { setShowLogoutModal(false); handleLogout(); }} className="w-full text-white py-2 rounded-[4px] text-[14px] font-medium sm:py-3 bg-gradient-primary border-none transition-all duration-400 ease-in-out cursor-none"
                                            >
                                                Yes, Logout
                                            </button>
                                        </div>
                                    </div>
                                </Modal>
                            </motion.div>
                        ) : (
                            <motion.div
                                onClick={() => { navigate('/login') }}
                                className="relative gap-1 flex items-center text-gray-200 transition-all duration-300 hover:text-purple-400 group"
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <div className="w-8 h-8 rounded-full border-2 border-white/40 flex items-center justify-center transition-colors group-hover:border-purple-400">
                                    <FaUser size={16} />
                                </div>
                                <span
                                    className="transition-colors font-medium"
                                >
                                    Sign in
                                </span>
                                {/* <span style={{ minWidth: 0, maxWidth: '100%' }} className="absolute left-0 -bottom-1 w-0 h-[1px] bg-purple-400 transition-all duration-300 group-hover:w-full" /> */}
                                <span style={{ minWidth: 0, maxWidth: '100%' }} className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-0 h-[1px] bg-purple-400 transition-all duration-300 group-hover:w-full" />
                            </motion.div>
                        )}
                        <button onClick={() => setIsMenuOpen(true)} aria-label="Open menu">
                            <FaBars size={24} className="text-white" />
                        </button>
                    </div>

                    {/* Offcanvas Menu moved outside container to avoid clipping */}
                </div>
            </div>
            {/* Backdrop and Drawer rendered at header level to span full width */}
            <>
                {isMenuOpen && (
                    <div
                        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] md:hidden"
                        onClick={() => setIsMenuOpen(false)}
                    />
                )}
                <motion.div
                    initial={{ x: '-100%' }}
                    animate={{ x: isMenuOpen ? 0 : '-100%' }}
                    transition={{ type: 'tween', duration: 0.3 }}
                    className="fixed top-0 left-0 w-[82%] sm:w-72 max-w-[360px] h-full bg-[#0b0b0b]/95 shadow-2xl p-6 z-[70] flex flex-col space-y-6 md:hidden border-r border-white/10 overflow-y-auto pb-6"
                >
                    <div className="flex justify-between items-center mb-8">
                        <h2 className="text-2xl font-bold bg-gradient-to-r from-purple-500 via-fuchsia-500 to-indigo-500 bg-clip-text text-transparent">YOYO</h2>
                        <button onClick={() => setIsMenuOpen(false)} aria-label="Close menu">
                            <FaTimes size={24} className="text-white" />
                        </button>
                    </div>

                    {/* {navItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            end={item.path === '/'}
                            className={({ isActive }) => `text-gray-200 text-lg hover:text-white transition-colors ${isActive ? 'text-primary' : ''}`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            {item.name}
                        </NavLink>
                    ))} */}
                    {navItems.map((item) => {
                        // 'navigate' and 'location' are assumed to be available from `useNavigate()` and `useLocation()` hooks
                        // called at the top level of the Header component.
                        const isActive = item.path === '/' ? location.pathname === '/' : location.pathname.startsWith(item.path);
                        return (
                            <motion.div
                                key={item.path}
                                whileHover={{ scale: 1.05 }}
                                className="relative text-gray-200 transition-all duration-300 hover:text-white group px-2 lg:px-3 py-2 rounded-lg hover:bg-white/5"
                                onClick={() => { navigate(item.path); setIsMenuOpen(false); }}
                            >
                                <div className={`block relative cursor-none ${isActive ? 'text-purple-400' : ''}`}>
                                    <span className="relative inline-block">
                                        {item.name}
                                        <span
                                            className={`
                                                absolute left-1/2 -bottom-0.5
                                                -translate-x-1/2
                                                h-[1px]
                                                bg-purple-400
                                                rounded-full
                                                transition-all duration-300
                                                ${isActive ? 'w-full opacity-100' : 'w-0 opacity-0 group-hover:w-full group-hover:opacity-100'}
                                            `}
                                            style={{ minWidth: 0, maxWidth: '100%' }}
                                        />
                                    </span>
                                </div>
                            </motion.div>
                        );
                    })}
                </motion.div>
            </>
        </header>
    );
};

export default Header;